// import { useAuthStore } from "@/store";
// import { router } from "@/router";
import {
  loginAPI,
  refreshTokenAPI,
  validateTokenAPI,
  checkEmailAddressAPI,
  emailValidationAPI,
  getForgotPasswordValidationCodeAPI,
  validateForgotPasswordCodeAPI,
  resetForgotPasswordAPI,
  resendValidationEmailAPI,
} from '@/services';
// import { getMe } from "@/controllers";
import { addAdminRoutes } from '@/router/admin';
import { useAuthStore, useTeamStore } from '@/stores/index';
import { router } from '@/router/router';
import { jwtDecode } from 'jwt-decode';
import { IUserDTO } from '@/dtos';
import { addUserRoutes } from '@/router/user';

export async function login(username: string, password: string) {
  const loginParams = {
    email: username,
    password: password,
  };

  try {
    const user = await loginAPI(loginParams);

    if (user && user.token) {
      const auth = useAuthStore();

      const team = useTeamStore();
      const decUser: IUserDTO = jwtDecode(user.token);
      auth.setUserToken(user.token);
      auth.setRefreshToken(user.refreshToken);
      auth.isLoggedIn = true;
      if (decUser.role) {
        if (decUser.role.toString() == 'Admin') {
          await addAdminRoutes(router);
        } else {
          await addUserRoutes(router);
        }
        auth.setRole(decUser.role.toString());
      }
      auth.setData(JSON.stringify(user));

      if (auth.isAdmin) {
        await router.push({ name: 'Admin' });
      } else {
        await team.forceTeamUpdate();
        await router.push({ name: 'Home' });
      }
    } else {
      throw 'There was an error logging in. Please verify that you entered in the correct username and password.';
    }
  } catch (error) {
    if (error && error == 409) {
      throw { code: 409, msg: 'Please check your email to validate your account.' };
    }
    throw {
      code: 500,
      msg: 'There was an error logging in. Please verify that you entered in the correct username and password.',
    };
  }
}

export async function emailValidation(email_address: string, token: string): Promise<boolean> {
  try {
    return await emailValidationAPI(email_address, token);
  } catch (error: unknown) {
    throw error as string;
  }
}
export async function refreshToken() {
  try {
    await refreshTokenAPI();
  } catch (error: unknown) {
    throw error as string;
  }
}
export async function logout() {
  try {
    const auth = useAuthStore();
    await auth.logout();
    await router.push({ name: 'Login' });
  } catch (error: unknown) {
    throw error as string;
  }
}

export async function validateToken() {
  let isValid = false;
  try {
    isValid = await validateTokenAPI();
  } catch (error: unknown) {
    throw error as string;
  }
  return isValid;
}
//KEEP needed for Validation
export async function checkEmailAddress(email: string, userId?: string): Promise<boolean> {
  try {
    const valid = await checkEmailAddressAPI(email, userId);
    return valid;
  } catch {
    throw 'Error validating email address';
  }
}

export async function getForgotPasswordValidationCode(email: string): Promise<boolean> {
  try {
    const result = await getForgotPasswordValidationCodeAPI(email);
    return result;
  } catch (error: unknown) {
    throw error as string;
  }
}

export async function validateForgotPasswordCode(code: string, email: string): Promise<boolean> {
  try {
    const success = await validateForgotPasswordCodeAPI(code, email);
    return success;
  } catch (error: unknown) {
    throw error as string;
  }
}
export async function resetForgotPassword(code: string, email: string, password: string) {
  try {
    await resetForgotPasswordAPI(code, email, password);
  } catch {
    throw "Cant't reset password";
  }
}
export async function resendValidationEmail(email: string): Promise<boolean> {
  try {
    return await resendValidationEmailAPI(email);
  } catch (error: unknown) {
    throw error as string;
  }
}
